export default __webpack_public_path__ + "static/media/faceAddWithColletion.c6927da0.png";